import { TFunction } from "i18next";

import { CountTypeEnum } from "pages/Dashboard/components/constants";

import {
  FilterGroupState,
  FilterRowState,
} from "features/ui/Filters/FilterBuilder/types";
import {
  filterBuilderQueryToFilterBuilderState,
  mergeFilterGroupStates,
} from "features/ui/Filters/FilterBuilder/utils";

export const getCombinedEventFilters = (
  smartGroupID: string,
  eventFilters: FilterGroupState<FilterRowState>
): FilterGroupState<FilterRowState> => {
  const smartGroupFilter: FilterGroupState<FilterRowState> | undefined =
    filterBuilderQueryToFilterBuilderState(`smartGroups=in:${smartGroupID}`);

  // merge smart group filter with event filters
  // do not add shared table filters here, since they are passed to the component itself separately
  return mergeFilterGroupStates(smartGroupFilter, eventFilters);
};

export const getAccessors = (countType: CountTypeEnum) => {
  let filteredAccessor: string;
  let allTimeAccessor: string;

  switch (countType) {
    case CountTypeEnum.EVENT_COUNT:
      filteredAccessor = "filteredCount";
      allTimeAccessor = "allTimeCount";
      break;
    case CountTypeEnum.VEHICLE_COUNT:
      filteredAccessor = "filteredVehicleCount";
      allTimeAccessor = "allTimeVehicleCount";
      break;
    case CountTypeEnum.FRC_IMPACT:
      filteredAccessor = "filteredFRCImpact";
      allTimeAccessor = "allTimeFRCImpact";
      break;
  }

  return { filteredAccessor, allTimeAccessor };
};

export const getLabel = (
  countType: CountTypeEnum,
  eventLabel: string,
  t: TFunction
): { countLabel: string; chartLabel: string } => {
  const affectedVehiclesLabel = t(
    "common:analytics.by_age.affected_vehicles_label"
  );

  switch (countType) {
    case CountTypeEnum.EVENT_COUNT:
      return { countLabel: eventLabel, chartLabel: eventLabel };
    case CountTypeEnum.VEHICLE_COUNT:
      return {
        countLabel: affectedVehiclesLabel,
        chartLabel: affectedVehiclesLabel,
      };
    case CountTypeEnum.FRC_IMPACT:
      return {
        countLabel: t("schema:dashboard.frc_impact"),
        chartLabel: affectedVehiclesLabel,
      };
  }
};
